import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid, Typography } from '@material-ui/core';
import { Formik, Form as FormikForm, FormikHelpers } from 'formik';

import { ClientUrlParamsConfigurationInput } from 'api';
import { GridItem, ValidatedTextField } from 'components';
import { NewTrackingKeySchema } from 'features/admin/validations';

interface IProps {
  onAdd: (config: ClientUrlParamsConfigurationInput) => void;
}

const CreateTrackingKey: FC<IProps> = ({ onAdd }) => {
  const { t } = useTranslation();

  const initialValues: ClientUrlParamsConfigurationInput = {
    key: '',
  };

  function onSubmit(
    values: ClientUrlParamsConfigurationInput,
    actions: FormikHelpers<ClientUrlParamsConfigurationInput>
  ) {
    onAdd(values);
    actions.resetForm();
  }

  return (
    <Grid container spacing={3}>
      <Grid container item alignItems="center">
        <Grid item xs={12} sm={3}>
          <Typography variant="subtitle2">{t('parameters:trackingKeyNew')}</Typography>
        </Grid>
        <GridItem>
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={NewTrackingKeySchema}
            render={() => (
              <FormikForm>
                <Grid container spacing={2} alignItems="center">
                  <Grid xs item>
                    <ValidatedTextField
                      name="key"
                      i18nKey="parameters:trackingKeyPlaceholder"
                      TextFieldProps={{ margin: 'none', label: null }}
                    />
                  </Grid>
                  <Grid item>
                    <Button type="submit" variant="contained" color="primary">
                      {t('common:add')}
                    </Button>
                  </Grid>
                </Grid>
              </FormikForm>
            )}
          />
        </GridItem>
      </Grid>
    </Grid>
  );
};

export default CreateTrackingKey;
